import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import data from "./data.json";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";

import "../reports.css";
import styled from "styled-components";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class OperationMaintenanceReport extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
            checks: data,
        };

        if (path[2] === "reports") {
            props.getReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };

    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let dp = this.renderDropDown;
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let checkRowCount = 2;
        let RCount = 1;
        const { editing, checks, report } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Operation and Maintanence Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">
                        Operation and Maintanence Report
                    </Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Operation and Maintanence Report - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && <this.props.header />}
                            <div
                                className="imgDiv"
                                style={{
                                    float: "left",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography variant="h5">
                                    Operation and Maintanence Report
                                </Typography>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div style={gstyle(10, 13, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Report Details</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 7)}>
                                        <b>Shift:</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 7, true)}>
                                        {dp("shift", report.shift, [
                                            "Early",
                                            "Day",
                                            "Late",
                                            "Weekend",
                                        ])}
                                    </div>
                                    <div style={cstyle(2, 7, 2, 13)}>
                                        <b>Timestamp</b>
                                    </div>
                                    <div style={cstyle(2, 10, 2, 13, true)}>
                                        {report.timestamp}
                                    </div>
                                    <div style={cstyle(3, 1, 3, 7)}>
                                        <b>Schedule:</b>
                                    </div>
                                    <div style={cstyle(3, 4, 3, 7, true)}>
                                        {rT("schedule", report.schedule)}
                                    </div>
                                    <div style={cstyle(3, 7, 3, 13)}>
                                        <b>Mileage</b>
                                    </div>
                                    <div style={cstyle(3, 10, 3, 13, true)}>
                                        {report.vehicle_mileage
                                            ? report.vehicle_mileage
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(4, 1, 4, 7)}>
                                        <b>Date Start:</b>
                                    </div>
                                    <div style={cstyle(4, 4, 4, 7, true)}>
                                        {report.date_start
                                            ? report.date_start
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(4, 7, 4, 13)}>
                                        <b>Date End:</b>
                                    </div>
                                    <div style={cstyle(4, 10, 4, 13, true)}>
                                        {report.date_end
                                            ? report.date_end
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 7)}>
                                        <b>Time Start:</b>
                                    </div>
                                    <div style={cstyle(5, 4, 5, 7, true)}>
                                        {report.time_start
                                            ? report.time_start
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(5, 7, 5, 13)}>
                                        <b>Time End:</b>
                                    </div>
                                    <div style={cstyle(5, 10, 5, 13, true)}>
                                        {report.time_end
                                            ? report.time_end
                                            : "N/A"}
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    clear: "both",
                                }}
                            >
                                <div style={gstyle(9, 13, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 5, false, true)}
                                    >
                                        <b>Team - Maintanence</b>
                                    </div>
                                    <div
                                        style={cstyle(1, 5, 1, 13, false, true)}
                                    >
                                        <b>Machinery / Vehicles / Tools</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2, false)}>
                                        <b>#</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 4, false)}>
                                        <b>Employee</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 5, false)}>
                                        <b>Hours</b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 6, false)}>
                                        <b>Code</b>
                                    </div>
                                    <div style={cstyle(2, 6, 2, 8, false)}>
                                        <b>Catagory</b>
                                    </div>
                                    <div style={cstyle(2, 8, 2, 9, false)}>
                                        <b>Model</b>
                                    </div>
                                    <div style={cstyle(2, 9, 2, 10, false)}>
                                        <b>Licence Plate</b>
                                    </div>
                                    <div style={cstyle(2, 10, 2, 11, false)}>
                                        <b>Hours Used</b>
                                    </div>
                                    <div style={cstyle(2, 11, 2, 12, false)}>
                                        <b>Start KM</b>
                                    </div>
                                    <div style={cstyle(2, 12, 2, 13, false)}>
                                        <b>End KM</b>
                                    </div>
                                    {checks.map((f) => {
                                        checkRowCount++;

                                        return (
                                            <React.Fragment key={checkRowCount}>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        1,
                                                        checkRowCount,
                                                        2
                                                    )}
                                                >
                                                    {f.id}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        2,
                                                        checkRowCount,
                                                        4
                                                    )}
                                                >
                                                    {rT(
                                                        f.emp_name,
                                                        report[f.emp_name]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        4,
                                                        checkRowCount,
                                                        5,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.hours_et,
                                                        report[f.hours_et]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        5,
                                                        checkRowCount,
                                                        6,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.code_et,
                                                        report[f.code_et]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        6,
                                                        checkRowCount,
                                                        8,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.catagory,
                                                        report[f.catagory]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        8,
                                                        checkRowCount,
                                                        9,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.model,
                                                        report[f.model]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        9,
                                                        checkRowCount,
                                                        10,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.licence_plate,
                                                        report[f.licence_plate]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        10,
                                                        checkRowCount,
                                                        11,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.hours_used,
                                                        report[f.hours_used]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        11,
                                                        checkRowCount,
                                                        12,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.start_km,
                                                        report[f.start_km]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        12,
                                                        checkRowCount,
                                                        13,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.end_km,
                                                        report[f.end_km]
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    clear: "both",
                                }}
                            >
                                <div style={gstyle(9, 13, null)}>
                                    <div style={cstyle(1, 1, 1, 2, false)}>
                                        <b>#</b>
                                    </div>
                                    <div style={cstyle(1, 2, 1, 3, false)}>
                                        <b>WO ref</b>
                                    </div>
                                    <div style={cstyle(1, 3, 1, 4, false)}>
                                        <b>Activity Code</b>
                                    </div>
                                    <div style={cstyle(1, 4, 1, 5, false)}>
                                        <b>C/W</b>
                                    </div>
                                    <div style={cstyle(1, 5, 1, 6, false)}>
                                        <b>From</b>
                                    </div>
                                    <div style={cstyle(1, 6, 1, 7, false)}>
                                        <b>To</b>
                                    </div>
                                    <div style={cstyle(1, 7, 1, 8, false)}>
                                        <b>Lead Time</b>
                                    </div>
                                    <div style={cstyle(1, 8, 1, 9, false)}>
                                        <b># of Units</b>
                                    </div>
                                    <div style={cstyle(1, 9, 1, 10, false)}>
                                        <b>Unit of Measure</b>
                                    </div>
                                    <div style={cstyle(1, 10, 1, 13, false)}>
                                        <b>Work Description</b>
                                    </div>

                                    {checks.map((f) => {
                                        RCount++;

                                        return (
                                            <React.Fragment key={RCount}>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        1,
                                                        RCount,
                                                        2
                                                    )}
                                                >
                                                    {f.id}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        2,
                                                        RCount,
                                                        3
                                                    )}
                                                >
                                                    {rT(
                                                        f.wo_et,
                                                        report[f.wo_et]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        3,
                                                        RCount,
                                                        4
                                                    )}
                                                >
                                                    {rT(
                                                        f.activity_code,
                                                        report[f.activity_code]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        4,
                                                        RCount,
                                                        5,
                                                        true
                                                    )}
                                                >
                                                    {rT(f.cw, report[f.cw])}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        5,
                                                        RCount,
                                                        6,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.from_et,
                                                        report[f.from_et]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        6,
                                                        RCount,
                                                        7,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.to_et,
                                                        report[f.to_et]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        7,
                                                        RCount,
                                                        8,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.lead_time,
                                                        report[f.lead_time]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        8,
                                                        RCount,
                                                        9,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.num_of_units,
                                                        report[f.num_of_units]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        9,
                                                        RCount,
                                                        10,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.unit_measure,
                                                        report[f.unit_measure]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        RCount,
                                                        10,
                                                        RCount,
                                                        13,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.work_desc,
                                                        report[f.work_desc]
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>

                            <div style={{ width: "100%" }}>
                                <div style={gstyle(3, 13)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Other Comments</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 13, true)}>
                                        {report.extra_comments
                                            ? report.extra_comments
                                            : "N/A"}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div style={gstyle(7, 13)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Vehicle Damage</b>
                                    </div>

                                    <div style={cstyle(2, 1, 2, 13)}>
                                        <b>Is Vehicle Damaged:</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 13, true)}>
                                        {report.vehicle_damage
                                            ? report.vehicle_damage
                                            : "N/A"}
                                    </div>
                                    <div style={cstyle(3, 1, 3, 13)}>
                                        <b>Damage Details:</b>
                                    </div>
                                    <div style={cstyle(3, 4, 5, 13, true)}>
                                        {report.vehicle_damage_description
                                            ? report.vehicle_damage_description
                                            : "N/A"}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div style={gstyle(7, 13)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Signature / Approval</b>
                                    </div>

                                    <div style={cstyle(2, 1, 4, 7, true)}>
                                        <img
                                            src={
                                                report.supervisor_sig_url ===
                                                    undefined ||
                                                report.supervisor_sig_url ===
                                                    null ||
                                                report.supervisor_sig_url === ""
                                                    ? noImg
                                                    : report.supervisor_sig_url
                                            }
                                            alt="Signature"
                                            style={{
                                                width: "auto",
                                                minHeight: "30px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(4, 1, 5, 7)}>
                                        <b>SUPERVISOR</b>
                                    </div>
                                    <div style={cstyle(2, 7, 4, 13, true)}>
                                        <img
                                            src={
                                                report.notifier_sig_url ===
                                                    undefined ||
                                                report.notifier_sig_url ===
                                                    null ||
                                                report.notifier_sig_url === ""
                                                    ? noImg
                                                    : report.notifier_sig_url
                                            }
                                            alt="Signature"
                                            style={{
                                                width: "auto",
                                                minHeight: "30px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(4, 7, 5, 13)}>
                                        <b>MANAGER</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* {this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )} */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                            this.props.setActivity(
                                                "update",
                                                "report",
                                                this.state.reportType
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, setActivity }
)(OperationMaintenanceReport);
